.dialog {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  width: fit-content;
  min-width: 600px;
  height: fit-content;
  bottom: 0;
  background: var(--dialog-background);
  border-color: var(--box-border-color);
  border-width: 1px;
  border-radius: 4px;
  color: var(--main-text);
  padding: 0;
  text-align: left;
  overflow: visible;
  max-height: 80vh;
  max-width: 800px;
}

@media (max-width: 600px) {
  .dialog {
    min-width: unset;
    width: 95vw;
    max-width: 95vw;
    left: 2.5vw;
    right: 2.5vw;
  }
}

.dialog[open] {
  flex-direction: column;
}

.dialog-container {
  flex: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.dialog form {
  flex: 1;
  overflow: auto;
}

.field-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}

.field-group .field {
  margin-bottom: 0;
}

.field-group .label {
  margin-bottom: 0;
}

.field-group .field:last-child {
  margin-bottom: 0;
}

.dialog::backdrop {
  background: rgb(0 0 0 / 50%);
}

.dialog textarea {
  width: 100%;
  height: auto;
}

.dialog h2 {
  box-sizing: border-box;
  margin: 0;
  font-weight: normal;
  font-size: 1rem;
  font-weight: bold;
}

.body {
  padding: 1rem 2rem;
  display: flex;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
}

.label {
  color: var(--dialog-label-color);
  font-size: 0.8rem;
}

.hint {
  color: var(--secondary-text);
  font-size: 0.75rem;
  margin: 4px 0 0;
  line-height: 1.4;
}

.hintList {
  color: var(--secondary-text);
  font-size: 0.75rem;
  margin: 4px 0 0;
  padding-left: 1.2em;
  line-height: 1.4;
}

.hintList li {
  margin-bottom: 2px;
}

.field {
  font-size: 90%;
  display: flex;
  flex-direction: column;
  margin: 7px 0 21px 0;
}

.field textarea {
  background: var(--main-background);
  border-radius: 4px;
  color: var(--main-text);
  font-family: inherit;
  font-size: 100%;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
}

.field input[type="radio"] + label {
  margin-left: 7px;
}

.field input[type="number"],
.field input[type="text"] {
  padding: 7px;
}

.label:has(+ .field input:required)::after {
  content: " *";
  color: red;
}

.option,
.option input,
.option label {
  cursor: pointer;
}

.autocomplete {
  background: var(--main-background);
}

.buttons {
  text-align: right;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 1rem 2rem;
}

.buttons.in-header {
  position: absolute;
  bottom: auto;
  top: 0.1rem;
  left: auto;
  margin: 0;
  padding: 1rem 0;
  right: 3.5rem;
}

.close-button {
  position: absolute;
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
  right: 1rem;
  border: 0;
  padding: 0;
  margin: 0;
  background: none;
}

.error {
  color: #f77;
  padding: 15px 50px;
  background: var(--dialog-error-background);
}

.overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--overlay-color);
  opacity: 0.2;
}

.overlay::after {
  content: url(/loading.svg);
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -19px;
}

.dialog-header {
  display: flex;
  align-items: center;
  height: 2rem;
  background-color: var(--main-background);
  padding: 1rem 3.5rem 1rem 2rem;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.dialog-close-icon {
  font-size: 20px;
  cursor: pointer;
  border: none;
  background: none;
}
